import {useSelector, type TypedUseSelectorHook} from 'react-redux'
import {type AppState} from '../store/types/app-state'

const useTypedSelector: TypedUseSelectorHook<AppState> = useSelector

export default useTypedSelector
